import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/app.css';
// import MishaafLogo from './MishaafLogo';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Navbar />
      {/* <MishaafLogo /> */}
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
